// import React from 'react'
import ReactDOM from 'react-dom/client'
import React from 'react'
import App from './app'
import './index.css'
import '@/i18n/i18n'
import { QueryClient, QueryClientProvider } from 'react-query'
import ErrorBoundary from './components/error-boundary/ErrorBoundary'
import queryClientConfig from 'project-config/services/request/query-client-config'
import { ThemeProvider } from 'styled-components'
import ThemeManager from 'project-config/services/theme-manager'

export const queryClient = new QueryClient(queryClientConfig)

export function Entry() {
  ThemeManager.init()
  const newTheme = ThemeManager.newTheme
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <ThemeProvider theme={newTheme as any}>
          <App />
        </ThemeProvider>
      </ErrorBoundary>
    </QueryClientProvider>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(React.createElement(Entry))
